import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

import SearchBar from 'components/SearchBar'

import useDebounce from 'hooks/useDebounce'
import { fetchFilteredAndPaginatedCustomPaymentTypes } from 'store/CustomPaymentTypes/actions'
import { setQueryStringParameters } from 'store/AppState/actions'

const ListFilters = ({ queryStringParametersWithVenue }) => {
  const [searchQuery, setSearchQuery] = useState(
    queryStringParametersWithVenue?.searchFor
  )

  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const history = useHistory()

  const debouncedFetchSalesEventsWithSearchParams = useDebounce(
    () => {
      const updatedParams = {
        ...queryStringParametersWithVenue,
        page: 1,
        searchFor: searchQuery,
      }

      dispatch(
        fetchFilteredAndPaginatedCustomPaymentTypes(updatedParams)
      )
      dispatch(setQueryStringParameters(updatedParams, pathname))
    },
    500
  )

  const handleSearch = (value) => {
    setSearchQuery(value)

    debouncedFetchSalesEventsWithSearchParams()
  }

  const redirectToAddNew = () =>
    history.push({ state: { customTenderUuid: 'new' } })

  return (
    <div className="custom-tenders-filters">
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchQuery}
      />
      <button
        data-cy="new-custom-tender-btn"
        className="btn new-item"
        type="button"
        onClick={redirectToAddNew}
      >
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default ListFilters
